import {ModalContext} from "../contexts/ModalContext.tsx";
import {ReactNode, useEffect, useState} from "react";
import {XMarkIcon} from "@heroicons/react/24/solid";
import {ChevronLeftIcon} from "@heroicons/react/24/outline";

interface IProps {
    children: ReactNode;
}

const ModalProvider = ({children}: IProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isBackButtonVisible, setIsBackButtonVisible] = useState(false);
    const [content, setContent] = useState<ReactNode>();
    const [header, setHeader] = useState<ReactNode>();
    const [maxHeightDesktop, setMaxHeightDesktop] = useState<string>();
    const [backButtonAction, setBackButtonAction] = useState<(() => void) | undefined>(undefined);
    const [isVisible, setIsVisible] = useState(false);
    const [animationClass, setAnimationClass] = useState<'animate-opacityEaseIn' | 'animate-opacityEaseOut'>('animate-opacityEaseIn');

    const handleSetBackButtonAction = (action: (() => void) | undefined) => {
        // Ta funkcja po prostu ustawia stan na przekazaną akcję
        setBackButtonAction(() => action);
    }
    const showModal = (header: ReactNode, content: ReactNode, maxHeightDesktop?: string) => {
        setMaxHeightDesktop(maxHeightDesktop ?? "75%");
        setHeader(header);
        setContent(content);
        setIsOpen(true);
    }
    const closeModal = () => {
        setIsOpen(false);
        setIsBackButtonVisible(false);
        setHeader(undefined);
        setContent(undefined);
        setBackButtonAction(undefined);

    }

    useEffect(() => {
        if (isOpen) {
            setIsVisible(true); // animacja otwarcia
            setAnimationClass('animate-opacityEaseIn');

        } else {
            // przy zamykaniu, zostaw modal w DOM przez czas animacji
            setAnimationClass('animate-opacityEaseOut');

            const timer = setTimeout(() => setIsVisible(false), 300); // 300ms = czas animacji
            return () => clearTimeout(timer);
        }
    }, [isOpen]);

    return (
        <ModalContext.Provider
            value={{
                isOpen,
                isBackButtonVisible,
                showModal,
                closeModal,
                setIsBackButtonVisible,
                setBackButtonAction: handleSetBackButtonAction
            }}>
            {children}
            {isVisible &&
                <div
                    className={`fixed top-0 left-0 w-screen h-screen z-[60] ${animationClass}`}>
                    <div className={"relative w-full h-full flex"}>
                        <div className={"absolute bg-neutral-900/70 w-full h-full"} onClick={closeModal}/>
                        <div
                            style={{maxHeight: window.innerWidth > 768 ? maxHeightDesktop : "none"}}
                            className={`relative md:max-w-2xl z-10 w-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 p-1 ${content != null && 'h-full'}`}>
                            <div
                                className={"rounded-3xl bg-neutral-700 w-full h-full overflow-hidden border border-neutral-500 flex flex-col"}>

                                <div className={"flex items-start justify-between pt-4 pr-4 gap-8 flex-shrink-0"}>
                                    <div
                                        className={`flex items-start gap-4 transition ${isBackButtonVisible ? "translate-x-4" : "-translate-x-11"} `}>
                                        <button
                                            className={"relative w-10 h-10 border border-neutral-500 rounded-full bg-neutral-600 flex-shrink-0 hover:bg-neutral-500 transition"}
                                            onClick={backButtonAction}>
                                            <ChevronLeftIcon
                                                className={"absolute w-7 h-7 top-1/2 left-1/2 -translate-x-[55%] -translate-y-1/2"}/>
                                        </button>
                                        {header}
                                    </div>

                                    <button
                                        className={"border border-neutral-500 rounded-full p-1.5 bg-neutral-600 hover:bg-neutral-500 transition"}
                                        onClick={closeModal}>
                                        <XMarkIcon className={"w-7 h-7"}/>
                                    </button>
                                </div>

                                <div className={"flex-1 overflow-hidden"}>
                                    {content}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
        </ModalContext.Provider>
    );
};

export default ModalProvider;